<div class="reporting-periods-list">
  <h2 class="periods-heading">Reporting periods</h2>
  <p class="periods-subheading">
    Select a period to start or continue your submission. Submit at least once a
    year to continue being listed under the HAIP Brand; responses can be carried
    forward from previous periods.
  </p>

  @if ($profileIncomplete()) {
    <div class="notification is-warning">
      Your organization profile is incomplete. Please <a routerLink="/users/myself">complete your profile</a> before creating a new report.
    </div>
  }

  <div class="periods-card">
    @for (group of $periodsByYear(); track group.year) {
      <div class="message is-light year-section">
        <div class="message-header year-section-header">
          <p>{{ group.year }}</p>
        </div>
        <div class="message-body p-0">
          @for (period of group.periods; track period.value) {
            <div
              class="period-row"
              [class.is-disabled]="$profileIncomplete() && period.status === notStartedStatus"
              role="button"
              tabindex="0"
              (click)="!($profileIncomplete() && period.status === notStartedStatus) && onSelect(period)"
              (keydown.enter)="!($profileIncomplete() && period.status === notStartedStatus) && onSelect(period)"
              (keydown.space)="!($profileIncomplete() && period.status === notStartedStatus) && onSelect(period); $event.preventDefault()"
            >
              <div class="period-info">
                <span class="period-label">{{ period.label }}</span>
              </div>
              <div class="period-actions">
                <span [class]="'status-badge status-' + period.status">
                  {{ statusLabels[period.status] }}
                  @if (period.status === 'draft' && period.submission) {
                    ({{ period.submission.completionPercentage }}%)
                  }
                </span>
                <span class="period-chevron">&rsaquo;</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
